// eslint-disable-next-line import/no-restricted-paths
import { GeneralOfferSelectionType } from '~/admin/offers/shared/types';
import {
  SET_OFFER_DETAILS,
  SET_ORDERING_OFFER_DETAILS,
  CLEAR_OFFER_DETAILS,
  SET_MARKETING_OFFER_DETAILS,
  CLEAR_MARKETING_OFFER_DETAILS,
} from './OffersActions';

const initialState = {
  marketingOfferValues: {},
  offerValues: {
    generalOfferSelectionType: GeneralOfferSelectionType.Menu,
  },
};

const offers = (state = initialState, action) => {
  switch (action.type) {
    case SET_OFFER_DETAILS:
      return {
        ...state,
        offerValues: action.offerValues,
      };
    case SET_ORDERING_OFFER_DETAILS:
      return {
        ...state,
        offerValues: {
          ...state.offerValues,
          ...action.orderingOfferDetails,
        },
      };
    case CLEAR_OFFER_DETAILS:
      return initialState;
    case SET_MARKETING_OFFER_DETAILS:
      return {
        ...state,
        marketingOfferValues: action.offerValues,
      };
    case CLEAR_MARKETING_OFFER_DETAILS:
      return initialState;
    default:
      return state;
  }
};

export default offers;
